export default {
  es: {
    enlaces: {
      ajusath: "/ajusath",
      productos: "/productos",
      tecnologia: "/tecnologia",
      proyectos: "/proyectos",
      contacto: "/contacto",
      trabaja_con_nosotros: "/trabaja-con-nosotros",
      mapa_web: "/mapa-web",
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      datos_seguros: "/tus-datos-seguros",
      aviso_legal: "/aviso-legal",
      textos: {
        inicio: "Inicio",
        ajusath: "Ajusa th",
        tecnologia: "Tecnología",
        productos: "Productos",
        proyectos: 'Proyectos I+D+I',
        contacto: "Contacto",
        trabaja_con_nosotros: "Trabaja con nosotros",
        mapa_web: "Mapa Web",
        politica_privacidad: "Política de privacidad",
        datos_seguros: "Tus datos seguros",
        politica_cookies: "Política de cookies",
        aviso_legal: "Aviso legal",
      }
    },
    home: {
      titulo: "<strong>Pioneros <br>en tecnología <br>del hidrógeno</strong>",
      entradilla: "El hidrógeno es la base de nuestros estudios e investigaciones. Desarrollamos proyectos que generan energía a través de sistemas eficientes, que respetan el medio ambiente.",
      boton_video: "VER VÍDEO",
      seccionCreamos: {
        creamos: "Creamos",
        futuro: "un futuro",
        sostenible: "sostenible",
        description: "Investigación constante. Aplicamos la última tecnología en el desarrollo de múltiples proyectos con tecnología PEM."
      },
      seccionPie: {
        quienessomos: {
          title: "QUIÉNES SOMOS ",
          description: "Líderes en desarrollo de novedosos sistemas de energía propulsados por la tecnología del hidrógeno. Buscamos nuevas alternativas a los recursos que actualmente tenemos disponibles y que son limitados.",
        },
        tecnologia: {
          title: "TECNOLOGÍA ",
          description: "Proyectos de investigación y desarrollo que generan electricidad con combustibles alternativos. Tecnología de vanguardia para garantizar la máxima calidad en nuestros productos. ",
        },
        productos: {
          title: "PRODUCTOS ",
          description: "Amplío catálogo de productos. Sistemas de potencia, pilas de combustibles y componentes de pilas. Ajusa Tecnología del Hidrógeno es reconocida internacionalmente por sus múltiples proyectos de I+D+I. ",
        }
      }
    },
    Ajusath: {
      titulo: "<strong>TRABAJAMOS CON </strong><br> HIDRÓGENO</strong>",
      entradilla: "Ajusa Tecnologías del Hidrógeno es una empresa pionera en economía del Hidrógeno. Nace en 2002 con la finalidad de mantener el compromiso de Ajusa con la investigación y con los recursos que actualmente tenemos disponibles y son limitados.",
      vanguardia: {
        title: "VANGUARDIA",
        description: "Generamos electricidad de manera sostenible, utilizando combustibles actuales.",
      },
      tecnologia: {
        title: "TECNOLOGÍA",
        description: "Sofisticada tecnología aplicada a proyectos de investigación que generan electricidad con combustibles alternativos. Alta eficiencia con agua como única emisión.",
      },
      desarrollo: {
        title: "DESARROLLO",
        description: "Modernos laboratorios de pruebas y personal altamente cualificado.",
      },
      sostenibilidad: {
        title: "SOSTENIBILIDAD",
        description: "Cuidamos el lugar en el que vivimos y somos respetuoso con el planeta.",
      },
      nuestra_energia: "NUESTRA ENERGÍA ES LIMPIA Y EFICIENTE ",
      boton_consciencia: {
        nombre: "CONCIENCIA MEDIO AMBIENTAL",
        descarga: "/static/pdf/consciencia-medioambiental.pdf",
      },

    },
    tecnologia: {
      titulo: "<strong>TECNOLOGÍA</strong>",
      entradilla: "Creamos un futuro sostenible a través del desarrollo de energías alternativas basadas en el uso de hidrógeno",
      boton_video: "VER VÍDEO",
      lideres_descripcion: "Líderes en el desarrollo de Pilas de Combustión. Las pilas PEM son dispositivos electroquímicos alimentados por gas hidrógeno y aire, que producen potencia eléctrica y calor de forma continua.",
      boton_como_funciona: "¿CÓMO FUNCIONA UNA PILA PEM?",
      text_lab_pila1: "Ajusa TH tiene un <strong style='font-weight: 800'>laboratorio de ensayo de pilas de combustible</strong> de hasta 12kW, que será ampliado hasta 100kW durante 2024. Cuenta con espectrómetro de masas, prueba de celda única, prueba de fuga de helio, potenciostato/galvanostato y capacidad de diseño CFD. </p>",
      text_lab_pila2: "<p><strong style='font-weight: 800'>Capacidad para producir en serie placas y juntas bipolares de pilas de combustible PEM: </strong> estampación y embutición de precisión, corte/perfilado láser a partir de chapa o bobina, e inyección de plásticos termoestables de silicona líquida.</p>",
      boton_descarga: "/static/pdf/como-funciona-una-pila-pem.pdf",
      aplicaciones_sistema: "APLICACIONES DEL SISTEMA CON <strong>PEMFC</strong>",
      aplicaciones_descripcion: "Los sistemas de respaldo con PEMFC aseguran el suministro de potencia eléctrica cuando se produce un fallo en la red. Permiten que aplicaciones críticas alimentadas mediante red eléctrica, como torres de comunicaciones, centros de procesos de datos y servicios de emergencia, funcionen ininterrumpidamente.",
      banner_textos: {
        autonomia: "Larga autonomía",
        funcionamiento: "Funcionamiento silencioso",
        mantenimiento: "Bajo mantenimiento",
        SAI: "Función SAI (Sistema de Alimentación Ininterrumpida)",
        medioambiente: "Respetuosas con el medioambiente",
      },
      comunicacion_telefonia: "TORRES DE COMUNICACIÓN PARA TELEFONÍA Y RADIO",
      comunicacion_description: "Utilizadas por las compañías de distribución eléctrica para supervisar e informar a una unidad de control central del estado de la red eléctrica. Suelen tener un consumo eléctrico menor a los 2 kW.",
      proceso_datos: "CENTRO DE PROCESO DE DATOS",
      proceso_datos_description: "Centros con gran cantidad de ordenadores, servidores y equipos informáticos que necesitan un suministro ininterrumpido de potencia eléctrica. Su consumo es muy variable, pero las potencias más normales están entre 5 y 50 kW.",
      servicio_emergencia: "SERVICIO DE EMERGENCIA EN HOSPITALES",
      servicio_emergencia_description: "Los servicios de emergencia de hospitales, como quirófanos o UCI’s, deben estar operativos las 24 horas al día. Para protegerlos de los fallos de la red eléctrica, están equipados con sistemas de respaldo que suministran potencia eléctrica cuando la red no está disponible.",
    },
    productos: {
      titulo: "<strong>PRODUCTOS</strong>",
      entradilla: "Trabajo constante en varias líneas de investigación que nos permiten desarrollar una amplía oferta de productos y servicios.",
      sistema_ponencia: {
        title: "<p>SISTEMAS DE <strong>POTENCIA</strong></p>",
        description: "Solución perfecta para cortes ocasionales de la red eléctrica. Funcionamiento silencioso y con bajo mantenimiento. Incluye función SAI (Sistema de Alimentación Ininterrumpida), con posibilidad de monitorización remota.",
        descargas: {
          ponencia1200w: {
            nombre: "SISTEMAS DE POTENCIA de 1200W",
            descarga: "/static/pdf/Tablas1200W.pdf",
          },
          ponencia500AC: {
            nombre: "SISTEMA DE POTENCIA NOIL 5000AC UPS",
            descarga: "/static/pdf/Tabla3_5000w.pdf",
          },
          ponencia10k: {
            nombre: "SISTEMAS DE POTENCIA DE 10K",
            descarga: "/static/pdf/Tabla4_10kw.pdf",
          },
          ponencia7500k: {
            nombre: 'SISTEMAS DE POTENCIA de 7500W '
          }
        }
      },
      sistema_pilas: {
        title: "<p><strong>PILAS </strong>DE COMBUSTIBLE</p>",
        description_1: "Fabricamos pilas estándar con potencias entre 1 y 12 kW, con placas bipolares de composite de grafito (modelos FC020 y FC021) y también con placas de acero inoxidable (modelo FC024).",
        description_2: "Las posibilidades de las pilas son infinitas, por ello en Ajusa Tecnologías del Hidrógeno también diseñamos y desarrollamos las pilas a medida y bajo requerimientos específicos de cada cliente.",
        nombre: "PILAS AJUSA",
        descarga: "/static/pdf/pilas.pdf"
      },
      componentes_pilas: {
        title: "<p><strong>COMPONENTES</strong> DE LAS PILAS</p>",
        description: "Las partes de las que se compone una pila de combustión son en sí mismas componentes con uso particular que AJUSA Tecnologías de Hidrógeno también pone a disposición de los clientes.",
        placas: {
          nombre: "PLACAS BIPOLARES METÁLICAS O DE COMPOSITE DE GRAFITO",
          descarga: "/static/pdf/PlacaBipolar.pdf",
        },
        MEA: {
          nombre: "MEA (MEMBRANE ELECTRODE ASSEMBLY)",
          descarga: "/static/pdf/MEA(Montajedeelectrodosymembrana).pdf",
        },
        juntas: {
          nombre: "JUNTAS",
          descarga: "/static/pdf/Junta.pdf",
        },
        colector: {
          nombre: "COLECTORES DE CORRIENTE",
          descarga: "/static/pdf/Colectordecorriente.pdf",
        },
        placas_comprension: {
          nombre: "PLACAS DE COMPRESIÓN",
          descarga: "/static/pdf/Placadecompresion.pdf",
        },

      },
      estacion_servicio: {
        titulo: "<strong>ESTACIÓN DE SERVICIO</strong><br> DE HIDRÓGENO",
        carasteristicas: "<li style='list-style:disc'>Capacidad de almacenamiento de hidrógeno: 90 kg (3 186 l / 450 bar)</li><li style='list-style:disc'>Calidad: hidrógeno derivado de electrólisis (Hidrógeno Verde) según ISO 14687:2019</li><li style='list-style:disc'>Presión de entrega: 350 bar</li><li style='list-style:disc'>Potencia instalada: 31 kW</li><li style='list-style:disc'>Tipos de dispensador doble: TK25 / TK16</li><li style='list-style:disc'>Temperatura de Entrega: -20ºC</li><li style='list-style:disc'>Estación mantenida por Ajusa TH</li>"
      }

    },
    proyectos_IDI: {
      titulo: "<strong>PROYECTOS I+D+I</strong>",
      entradilla: "Pioneros en el desarrollo de proyectos de I+D+I que nos posicionan como empresa líder en la investigación y proyectos basados en la tecnología del hidrógeno.",
      hidrogen_station: {
        title: "DON QHYXOTE HYDROGEN STATION",
        description: "Ajusa Tecnologías del Hidrógeno ha desarrollado una estación de suministro de hidrógeno comprimido con el nombre Don Qhyxote Hidrogen Station.",
        description_2: "El hidrógeno es suministrado por un dispensador, cuya boquilla o boquerel es un componente normalizado en todo el mundo. Existen dos formatos: para coche y para camión. La presión de llenado es de 350 bar, y la hidrogenera cuenta con un almacén de 90 kilos de hidrógeno."
      },
      qhyxote_home: {
        title: "DON QHYXOTE<br> HOME",
        description: "El proyecto denominado Don Qhyxote Home, es un sistema de potencia principal de 10 kW. Está dedicado al suministro de toda la potencia eléctrica necesaria para una casa, que también suministra agua caliente. En este caso, el sistema es alimentado directamente con hidrógeno, pero hay un proyecto en curso para alimentarlo con gas natural o GLP mediante un reformador.",
      },
      qhyxote_car: {
        title: "DON QHYXOTE<br>CAR",
        description: "El proyecto denominado Don Qhyxote Car se trata de un coche eléctrico, movido por un motor de 4 kW que cuenta con baterías recargables para suministro de electricidad.",
        desplegable: {
          texto_1: "Tiene una autonomía de 50 km. El proyecto consistió en eliminar la mayor parte de las baterías y sustituirlas por un sistema de PEMFC. Los principales elementos del sistema son los siguienes:",
          texto_2: "Depósito de hidrógeno a presión. Contiene 1,8 kg de hidrógeno a 350 bares y proporciona una autonomía de 220 km.",
          texto_3: "Pila tipo PEMFC con PB de grafito. Tiene una potencia bruta de 10 kW. Está refrigerada por agua.",
          texto_4: "Sistema de refrigeración con radiador en la parte frontal del coche.",
          texto_5: "Sistema de control, con su unidad CPU y el software correspondiente.",
        },
      },
      qhyxote_scooter: {
        title: "DON QHYXOTE<br>SCOOTER",
        description: "El proyecto Don Qhyxote Scooter se trata de motos eléctricas adaptadas para personas con movilidad disminuida, en las que también se ha sustituido las baterías por un sistema de PEMFC. En este caso el hidrógeno se almacena en botellas de hidruros metálicos. Tiene la ventaja de que se almacena una gran cantidad de hidrógeno a baja presión.",
      },
      unidad_ponencia: {
        title: "UNIDAD DE POTENCIA<br>1,2 KW",
        description_1: "Este proyecto es el primer Sistema de Respaldo de 1,2 kW ensayado en condiciones normales de operación, en una instalación de torre de telecomunicaciones de la compañía Iberdrola.",
        description_2: "Localizado a 1600 metros de altura, con condiciones ambientales extremas, ha demostrado una completa fiabilidad durante dos años de funcionamiento. El armario incluye espacio para seis botellas de hidrógeno que proporciona una autonomía de hasta 1 semana de funcionamiento a los equipos de radio de la torre.",
      },
      cogeneracion: {
        title: "Sistemas de cogeneración<br>(mCHP System) ",
        description: "Se trata de un sistema prototipo, actualmente en fase de desarrollo, de cogeneración de electricidad y agua caliente utilizando pila de combustible PEM. Con estos sistemas se pretende utilizar tanto la electricidad como el calor producido por la pila de combustible para suministro de una vivienda.",
        desplegable: {
          texto_1: "En este caso, la potencia eléctrica suministrada será de 750 W. El calor se usa para calentar agua, que queda almacenada en un depósito para su uso también en la vivienda como agua caliente sanitaria.",
          texto_2: "Debido a que este sistema está funcionando muchas horas al año, están diseñados para consumir gas natural o GLP en lugar de hidrógeno, reduciendo el coste del combustible. Para ello el sistema incluye un reformador, que es un dispositivo que transforma el gas natural o el GLP en hidrógeno, con el cual se alimenta la pila de combustible.",
        },
      },
      modulo_extensor: {
        title: "Extensor de autonomía de 20kW ",
        description: "Desarrollo de un módulo extensor de rango de 20kW para vehículo o camión eléctrico de 12 toneladas utilizando la pila de combustible Ajusa FC030-250."
      },
      pila_combustible: {
        title: "Pila de <br> combustible <br>de 100 kW",
        description: "Ajusa está desarrollando una pila de combustible de 100kW, que estará disponible durante 2024."
      },
      submarino: {
        title: "PROYECTO PROPULSIÓN SUBMARINO S-80 PLUS",
        description: "Desarrollo de un Stack de 50kW para Submarino S80 Plus. Sistema de Propulsión Anaerobia (AIP, Air Independen Power), basado en pila de combustible. Sistema de 300kW (6 x 50 kW)."
      },
      otros_proyectos: {
        title: 'Otros <strong> proyectos</strong>',
      },
      cripicom: {
        title: "SISTEMA DEMO AERONÁUTICA | PILA DE COMBUSTIBLE DE 50 kW",
        description: "Junto a otras empresas como Destinus, Aerotecnic y ITP Aero, Ajusa TH trabaja en el desarrollo de un demostrador de tren de potencia con pilas de combustible dentro del Programa Tecnológico Aeronáutico 2022 Grandes Empresas. CRIPICOM: Criogenia, Pilas y combustión de hidrógeno en el trasporte aéreo."
      },
      aeronautica: {
        title: "SISTEMA DEMO AERONÁUTICA | PILA DE COMBUSTIBLE DE 50 kW",
        description1: "Junto a otras empresas como Destinus, Aerotecnic y ITP Aero, Ajusa TH trabaja en el desarrollo de un demostrador de tren de potencia con pilas de combustible dentro del Programa Tecnológico Aeronáutico 2022 Grandes Empresas. CRIPICOM: Criogenia, Pilas y combustión de hidrógeno en el trasporte aéreo.",
        description2: "El objetivo fundamental del proyecto CRIPICOM consiste en el desarrollo y ensayo de demostradores de sistemas indispensables para progresar en la maduración tecnológica de sistemas propulsivos aeronáuticos basados en la utilización de hidrógeno cubriendo el espectro de aplicaciones más amplio posible compatible con la utilización del mismo: desde pequeñas aeronaves con propulsión eléctrica, donde la pila de hidrógeno permitirá un incremento sustancial en alcance y carga de pago con respecto a las aeronaves con batería (pudiendo potencialmente cubrir parcialmente el segmento de la aviación regional), a aeronaves propulsadas con turbinas de gas con hidrógeno líquido como combustible, potencialmente aplicables a aeronaves comerciales de tamaño pequeño o medio.",
        description3: "Ajusa colabora en la línea de trabajo de desarrollo de un sistema de propulsión energizado por una pila de combustible, desarrollando y aportando el módulo de pila de combustible, en el que se integra su propio stack de 50 kW.",
        description4: "Proyecto financiado por la Unión Europea –NextGenerationEU, aunando esfuerzos con las prioridades políticas de la UE, es este caso con el Pacto Verde Europeo, cuyo impacto está transformando la UE en una economía moderna, eficiente en el uso de los recursos y competitiva: <a href='https://ec.europa.eu/info/strategy/priorities-2019-2024_es'><u>https://ec.europa.eu/info/strategy/priorities-2019-2024_es</u></a>"
      }
    },

    contacto: {
      titulo: "ATENCIÓN AL CLIENTE",
      formulario: {
        nombre_apellidos: "Nombre y apellidos*",
        empresa: "Empresa*",
        email: "Email*",
        mensaje: "Mensaje*",
        politicas: "Pulsa aquí para consultar y aceptar la política de privacidad",
        newsletter: "Quiero recibir noticias y novedades de Ajusa.",
        btn_enviar: "ENVIAR",
      },
      direccion: {
        titulo: "WORLDWIDE HEADQUARTERS",
        direccion: "Parque Empresarial Ajusa, Calle 1, nº1 · 02006 · ALBACETE (Spain) · Apdo./P.O. Box 415 (02080)",
        telefono: "Tfno.: +34 967 216 212",
        fax: "Fax: +34 967 216 214 - 967 240 499",
        email: "Email: <a href='mailto:ajusa@ajusa.es'>ajusa@ajusa.es</a>"
      },
      trabaja: {
        titulo: "TRABAJA CON NOSOTROS",
        texto: "En Ajusa trabajamos para crecer cada día, si deseas formar parte de nuestra gran familia, rellena este formulario y adjunta tu currículum.",
        envia_cv: "ENVIAR CURRICULUM",
      },
    },
    trabaja_con_nosotros: {
      intro: {
        titulo: "<span class='bold'>trabaja</span> con nosotros",
        texto: "En AJUSA siempre hay un espacio reservado para el talento. Trabajamos para crecer cada día. Si deseas formar parte de nuestra gran familia, rellena este formulario y adjunta tu currículum."
      },
      texto: "En Ajusa trabajamos para crecer cada día, si deseas formar parte de nuestra gran familia, rellena este formulario y adjunta tu currículum.",
      boton: "enviar curriculum"
    },
    formulario: {
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      area_interes: "Área de su interés",
      trabaja_actualmente: "¿Trabaja actualmente?",
      motivo: "Motivo de la consulta",
      si: "Sí",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      tipos_contacto: {
        'general': "General, contacto, sucursales",
        'comercial': "Comercial",
        'formacion': "Formación",
        'asistencia_tecnica': "Asistencia Técnica",
        'catalogo': "Solicitar catálogo en papel"
      },
      meses: {
        Enero: "Enero",
        Febrero: "Febrero",
        Marzo: "Marzo",
        Abril: "Abril",
        Mayo: "Mayo",
        Junio: "Junio",
        Julio: "Julio",
        Agosto: "Agosto",
        Septiembre: "Septiembre",
        Octubre: "Octubre",
        Noviembre: "Noviembre",
        Diciembre: "Diciembre"
      },
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      empresa: "Empresa",
      formulario: "Dirección completa (indique CP y localidad)",
      referencia: "Referencia de producto",
      introduce_mail: "Introduce tu email",
      tipo_catalogo: "Tipo de catálogo",
      pais: "País",
      telefono: "Teléfono",
      quiero_recibir: "Quiero recibir noticias y novedades de Ajusa.",
      acepto_comunicaciones: "Acepto recibir la newsletter u otras comunicaciones de su entidad.",
      otros_procesos: "Deseo ser tenido en cuenta en otros procesos de empleo de Ajusa que puedan resultar de mi interés",
      he_leido: "Consiento el uso de mis datos para los fines indicados en la",
      y_acepto: "política de privacidad",
      enviar_comentario: "Enviar Comentario",
      comentario_enviado: "Comentario enviado",
      texto_comentario_enviado: "Gracias por tu comentario. Lo revisaremos y publicaremos en el menor tiempo posible.",
      enviar: "Enviar",
      enviado: "Enviado",
      popup: {
        claim: "Pulsa aquí para consultar y aceptar la política de privacidad",
        intro: "INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS",
        textos: [{
            titulo: "Responsable del tratamiento",
            texto: "Auto Juntas SAU"
          },
          {
            titulo: "Dirección del responsable",
            texto: "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02006, Albacete (Albacete)"
          },
          {
            titulo: "Finalidad",
            texto: "Sus datos serán usados para poder atender sus solicitudes y prestarle nuestros servicios."
          },
          {
            titulo: "Publicidad",
            texto: "Solo le enviaremos publicidad con su autorización previa, que podrá facilitarnos mediante la casilla correspondiente establecida al efecto."
          },
          {
            titulo: "Legitimación",
            texto: "Únicamente trataremos sus datos con su consentimiento previo, que podrá facilitarnos mediante la casilla correspondiente establecida al efecto."
          },
          {
            titulo: "Destinatarios",
            texto: "Con carácter general, sólo el personal de nuestra entidad que esté debidamente autorizado podrá tener conocimiento de la información que le pedimos."
          },
          {
            titulo: "Derechos",
            texto: "Tiene derecho a saber qué información tenemos sobre usted, corregirla y eliminarla, tal y como se explica en la información adicional disponible en nuestra página web."
          },
          {
            titulo: "Información adicional",
            texto: "Más información en el apartado “SUS DATOS SEGUROS” de nuestra página web."
          }
        ],
        boton: "Entiendo"
      }
    },
    footer: {
      siguenos: "Síguenos",
      en_redes: "Síguenos en redes sociales",
      twitter: "Síguenos en X",
      facebook: "Síguenos en Facebook",
      instagram: "Síguenos en Instagram",
      canal: "Subscríbete al canal",
      contacto: "Contacto",
      mapa_web: "Mapa Web",
      Privacidad: "Política de privacidad",
      datos_seguros: "Tus datos seguros",
      cookies: "Política de cookies",
      aviso_legal: "Aviso legal",
    },
    error_404: {
      intro: "<span class='bold'>PÁGINA</span> NO ENCONTRADA",
      nombre: "Error 404",
      texto: "¡Lo sentimos! La página que estás intentando acceder ya no existe o se ha movido.",
      boton: "Volver al inicio"
    },
    otras_secciones: {
      productos: {
        titulo: "Productos",
        texto: "Trabajo constante en varias líneas de investigación que nos permiten desarrollar una amplía oferta de productos y servicios.",
        boton_texto: "Acceder"
      },
      tecnologia: {
        titulo: "Tecnología",
        texto: "Creamos un futuro sostenible a través del desarrollo de energías alternativas basadas en el uso de hidrógeno",
        boton_texto: "Acceder"
      },
      proyectos: {
        titulo: "Proyectos I+D+I",
        texto: "Pioneros en el desarrollo de proyectos de I+D+I que nos posicionan como empresa líder en la investigación y proyectos basados en la tecnología del hidrógeno.",
        boton_texto: "Acceder"
      }
    },
    banner_cookies: "Una cookie es un pequeño archivo de información que se guarda en su navegador cada vez que visita nuestra web. La utilidad de las cookies es guardar el historial de su actividad en nuestra para que, cuando la visite nuevamente, pueda identificarle y configurar su contenido en base a sus hábitos de navegación, identidad y preferencias. Pueden ser aceptadas, rechazadas, bloqueadas y borradas, según desee. En caso de que las rechace no podremos asegurarle el correcto funcionamiento de nuestra web. Más información en el apartado <router-link to='/politica-de-cookies'>política de cookies</router-link>.",
    boton_aceptar: "Aceptar",

  },

  en: {
    enlaces: {
      ajusath: "/ajusaht",
      contacto: "/contact",
      productos: "/products",
      tecnologia: "/tecnology",
      proyectos: "/projects",
      trabaja_con_nosotros: "/work-with-us",
      politica_privacidad: "/privacy-policy",
      politica_cookies: "/cookies-policy",
      mapa_web: "/web-map",
      datos_seguros: "/secure-data",
      aviso_legal: "/legal-notice",
      textos: {
        inicio: "Home",
        ajusath: "Ajusa th",
        tecnologia: "Tecnology",
        productos: "Products",
        proyectos: 'Projects I+D+I',
        contacto: "Contact",
        trabaja_con_nosotros: "Work with us",
        mapa_web: "Mapa Web",
        politica_privacidad: "Privacy Policy",
        datos_seguros: "Secure Data",
        politica_cookies: "Cookies Policy",
        aviso_legal: "Legal Notice",
        mapa_web: "Web Map",
      }
    },
    banner_cookies: "A cookie is a small data file that is stored in your browser each time you visit our website. Cookies are useful to save the history of your activity on our website so that when you visit it again, it can identify you and display its content based on your browsing habits, identity and preferences. Cookies can be accepted, rejected, blocked and deleted as desired. If you decide to reject them, we cannot guarantee the correct operation of our website. More information in the section <router-link to='/cookies-policy'>cookies policy</router-link>.",
    boton_aceptar: "Allow",
    home: {
      titulo: "<strong>Pioneers<br>in hydrogen <br>technology</strong>",
      entradilla: "Hydrogen is the basis of our studies and research. We develop projects that generate electricity using efficient, environmentally friendly systems.",
      boton_video: "PLAY VIDEO",
      seccionCreamos: {
        creamos: "We create",
        futuro: "a sustainable",
        sostenible: "future",
        description: "On-going research. We apply cutting-edge technology in the development of multiple projects using PEM technology."
      },
      seccionPie: {
        quienessomos: {
          title: "WHO WE ARE",
          description: "Leaders in the development of innovative energy systems powered by hydrogen technology. We seek new alternatives to currently available, limited resources.",
        },
        tecnologia: {
          title: "TECHNOLOGY ",
          description: "Research and development projects that generate electricity using alternative fuels. Cutting-edge technology to guarantee the highest quality in our products. ",
        },
        productos: {
          title: "PRODUCTS ",
          description: "Extensive product catalogue. Power systems, fuel cells and cell components. Ajusa Hydrogen Technology is internationally renowned for its multiple R&D&I projects. ",
        }
      }
    },
    Ajusath: {
      titulo: "WE WORK WITH <strong><br> HYDROGEN</strong>",
      entradilla: "Ajusa Hydrogen Technologies is a pioneering company in Hydrogen economy. It was incorporated in 2002 with the aim of maintaining Ajusa’s commitment to research using currently available, limited resources.",
      vanguardia: {
        title: "CUTTING EDGE",
        description: "We generate electricity sustainably using current fuels.",
      },
      tecnologia: {
        title: "TECHNOLOGY",
        description: "Sophisticated technology applied to research projects that generate electricity using alternative fuels. Highly efficient, with water as sole emission.",
      },
      desarrollo: {
        title: "DEVELOPMENT",
        description: "Modern testing laboratories and highly qualified personnel.",
      },
      sostenibilidad: {
        title: "SUSTAINABILITY",
        description: "We care about the place where we live and respect our planet.",
      },
      nuestra_energia: "OUR ELECTRICITY IS CLEAN <br>AND EFFICIENT ",
      boton_consciencia: {
        nombre: "ENVIRONMENTAL AWARENESS",
        descarga: "/static/pdf/enviornmentalCommitment.pdf",
      }

    },
    tecnologia: {
      titulo: "<strong>TECHNOLOGY</strong>",
      entradilla: "We create a sustainable future through the development of alternative energy sources based on the use of hydrogen.",
      boton_video: "PLAY VIDEO",
      lideres_descripcion: "Leaders in the development of Combustion Cells. PEM cells are electrochemical devices powered by hydrogen gas and air that continuously produce electrical power and heat.",
      boton_como_funciona: "HOW DOES A PEM CELL WORK?",
      text_lab_pila1: "Ajusa TH has a <strong style='font-weight: 800'>laboratory for fuel cell testing up</strong> to 12kW PEM type cell stacks. For 100kW we stacks will be available from early 2023. Testing facilities with mass spectrometer, single cell test station, helium leak testing, potentio stat/galvanostat and desing capability CFD.</p>",
      text_lab_pila2: "<p><strong style='font-weight: 800'>Ajusa TH has installed adaptable production capacity for series production of PEM </strong> fuel cell bipolar plates and seals: precision metal stamping and drawing, laser cutting/profiling from sheet or coil, injection moulding of liquid silicon thermosetting plastics.</p>",
      boton_descarga: "/static/pdf/pila_pem_en.pdf",
      aplicaciones_sistema: "<strong>PEMFC</strong> SYSTEM APPLICATIONS",
      aplicaciones_descripcion: "PEMFC backup systems ensure the electricity supply in the event of a network failure. They allow electricity-powered critical applications, such as communications towers, data processing centres and emergency services, to function uninterruptedly.",
      banner_textos: {
        autonomia: "Long life",
        funcionamiento: "Silent operation",
        mantenimiento: "Low maintenance",
        SAI: "UPS function (Uninterruptible Power Supply)",
        medioambiente: "Environmentally friendly",
      },
      comunicacion_telefonia: "COMMUNICATIONS TOWERS FOR TELEPHONY AND RADIO",
      comunicacion_description: "Used by electricity distribution companies to monitor and inform a central control unit on power grid status. They usually have a consumption of less than 2 kW.",
      proceso_datos: "DATA PROCESSING CENTRE",
      proceso_datos_description: "Centres with a large number of computers, servers and IT equipment that require an uninterrupted power supply. Their consumption varies widely, but normal power ratings range between 5 and 50 kW.",
      servicio_emergencia: "HOSPITAL EMERGENCY SERVICE",
      servicio_emergencia_description: "Hospital emergency services, such as operating theatres or ICUs, must be operational 24 hours a day. In order to protect them from power grid failures, they are equipped with backup systems that supply electricity when the grid is not available.",
    },
    productos: {
      titulo: "<strong>PRODUCTS</strong>",
      entradilla: "On-going work in various lines of research that allow us to develop an extensive product and service offering.",
      sistema_ponencia: {
        title: "<p><strong>POWER</strong> SYSTEMS</p>",
        description: "The perfect solution for occasional grid power outages. Silent operation and low maintenance. Includes UPS (Uninterruptible Power Supply) function, with remote monitoring possibility.",
        descargas: {
          ponencia1200w: {
            nombre: "POWER SYSTEM OF 1200W",
            descarga: "/static/pdf/Tablas_1200w_en.pdf",
          },
          ponencia500AC: {
            nombre: "NOIL 5000 AC UPS POWER SYSTEMS",
            descarga: "/static/pdf/Tabla3_5000w_en.pdf",
          },
          ponencia10k: {
            nombre: "10K POWER SYSTEMS",
            descarga: "/static/pdf/Tabla4_10kw_en.pdf",
          },
          ponencia7500k: {
            nombre: 'POWER SYSTEM OF 7500W'
          }
        }
      },
      sistema_pilas: {
        title: "<p>FUEL <strong>CELLS</strong></p>",
        description_1: "We manufacture standard cells with power ratings between 1 and 12 kW, with bipolar graphite composite plates (models FC020 and FC021) and also with stainless steel plates (model FC024).",
        description_2: "These cells have endless possibilities, which is why at Ajusa Hydrogen Technologies we also design and develop custom cells according to each customer’s specific needs.",
        nombre: "AJUSA CELLS",
        descarga: "/static/pdf/pilas_en.pdf"
      },
      componentes_pilas: {
        title: "CELL <strong>COMPONENTS</strong>",
        description: "The constituent parts of fuel cells are components in themselves with a specific use that AJUSA Hydrogen Technologies also places at its customer’s disposal.",
        placas: {
          nombre: "BIPOLAR GRAPHITE COMPOSITE AND METAL PLATES",
          descarga: "/static/pdf/Bipolarplate.pdf",
        },
        MEA: {
          nombre: "MEA (MEMBRANE ELECTRODE ASSEMBLY)",
          descarga: "/static/pdf/MEA(MembraneElectrodeAssembly).pdf",
        },
        juntas: {
          nombre: "GASKETS",
          descarga: "/static/pdf/Gasket.pdf",
        },
        colector: {
          nombre: "CURRENT COLLECTORS",
          descarga: "/static/pdf/Currentcollector.pdf",
        },
        placas_comprension: {
          nombre: "COMPRESSION PLATES",
          descarga: "/static/pdf/Compressionplate.pdf",
        },
      },
      estacion_servicio: {
        titulo: "HYDROGEN<br><strong> FUELLING STATION</strong><br> ",
        carasteristicas: "<li style='list-style:disc'>Storage capacity hydrogen: 90kg (3 186 l / 450 bar)</li><li style='list-style:disc'>Quality: hydrogen derived from electrolysis (Green Hydrogen) according to ISO 14687:2019</li><li style='list-style:disc'>Delivery pressure: 350 bar</li><li style='list-style:disc'>Installed power: 31 kW</li><li style='list-style:disc'>Double dispensor types: TK25 / TK16</li><li style='list-style:disc'>Delivery temperature: -20ºC</li><li style='list-style:disc'>Station maintained by Ajusa TH</li>"
      }

    },
    proyectos_IDI: {
      titulo: "<strong>R&D&I PROJECTS</strong>",
      entradilla: "Pioneers in the development of R&D&I projects that position us as the leading company in hydrogen technology research and projects.",
      hidrogen_station: {
        title: "DON QHYXOTE HYDROGEN STATION",
        description: "Ajusa Hydrogen Technologies has developed a compressed hydrogen supply station under the name Don Qhyxote Hydrogen Station.",
        description_2: "Hydrogen is supplied by a dispenser, whose nozzle is a component standardised worldwide. It comes in two formats: for cars and for trucks. Filling pressure is 350 bar and the hydro-generator has a 90 kilo hydrogen tank."
      },
      qhyxote_home: {
        title: "DON QHYXOTE<br> HOME",
        description: "The project called Don Qhyxote Home is a 10 kW main power system. It is dedicated to the supply of all the electricity needed for a house and also supplies hot water. In this case, the system is directly powered by hydrogen, but there is a project under way to feed it with natural gas or LPG using a reformer.",
      },
      qhyxote_car: {
        title: "DON QHYXOTE<br> CAR",
        description: "The project called Don Qhyxote Car consists of an electric car powered by a 4 kW motor equipped with rechargeable batteries to supply electricity.",
        desplegable: {
          texto_1: "It has a range of 50 km. The project consisted of removing most of the batteries and replacing them with a PEMFC system. The main elements of the system are as follows:",
          texto_2: "Pressurised hydrogen tank. Contains 1.8 kg of hydrogen at 350 bar and provides a range of 220 km.",
          texto_3: "PEMFC cell with graphite BP. It has a gross power rating of 10 kW. It is water-cooled.",
          texto_4: "Cooling system with radiator at the front of the car.",
          texto_5: "Control system, with its corresponding CPU and software.",
        },
      },
      qhyxote_scooter: {
        title: "DON QHYXOTE<br> SCOOTER",
        description: "The Don Qhyxote Scooter project consists of electric motorcycles for people with impaired mobility, in which the batteries have also been replaced by a PEMFC system. In this case, the hydrogen is stored in metal hydride cylinders. It has the advantage that a large quantity of hydrogen can be stored at low pressure.",
      },
      unidad_ponencia: {
        title: "POWER UNIT<br>1.2 KW",
        description_1: "This project is the first 1.2 kW Backup System tested under normal operating conditions in a telecommunications tower facility belonging to the company Iberdrola.",
        description_2: "Located at a height of 1,600 metres, under extreme environmental conditions, it has demonstrated complete reliability during two years of operation. The closet includes space for six hydrogen cylinders, which provide a range of up to one week of operation to the tower radio units.",
      },
      cogeneracion: {
        title: "Cogeneration system <br>(mCHP System) ",
        description: "It is a prototype electricity and hot water cogeneration system, currently in the development phase, powered by a PEM fuel cell. These systems are intended for using both the electricity and heat produced by the fuel cell to supply a house.",
        desplegable: {
          texto_1: "In this case, the electrical power supplied will be 750 W. The heat is used to heat water, which will be stored in a tank also for household use as sanitary hot water.",
          texto_2: "Since this system is functioning for many hours per year, it is designed to consume natural gas or LPG instead of hydrogen, reducing the cost of the fuel. To this end, the system includes a reformer, which is a device that transforms natural gas or LPG into hydrogen, which is fed to the combustion cell.",
        },
      },
      modulo_extensor: {
        title: "20kW range extender",
        description: "Development of a 20kW range extender module for a 12 tonne médium duty CV using an Ajusa FC030-250 stack."
      },
      pila_combustible: {
        title: "100 kW fuel cell  ",
        description: "Ajusa is developing a 100kW fuel cell, which will be available during 2024."
      },
      submarino: {
        title: "S-80 PLUS SUBMARINE PROPULSION PROJECT",
        description: "Development of a 50 kW fuel cell stack for S80 Plus Submarine. Anaerobic Propulsion System (AIP, Air Independent Power), based on fuel cell. 300 kW system (6 x 50 kW)."
      },
      otros_proyectos: {
        title: 'Other <strong> projects</strong>',
      },
      cripicom: {
        title: "AERONAUTICAL DEMO PROJECT | PEM FUEL CELL 50 Kw",
        description: "With other companies such as Destinus, Aerotecnic and ITP Aero, Ajusa TH is working on the development of a fuel battery power train demonstrator. Aeronautical Technological Program CRIPICOM."
      },
      aeronautica: {
        title: "AERONAUTICAL DEMO PROJECT | PEM FUEL CELL 50 Kw",
        description1: "With other companies such as Destinus, Aerotecnic and ITP Aero, Ajusa TH is working on the development of a fuel battery power train demonstrator. Aeronautical Technological Program CRIPICOM.",
        description2: "The fundamental objective of the CRIPICOM project is the development and testing of demonstrators for systems that are essential to advance the technological maturation of aeronautical propulsion systems based on the use of hydrogen, covering the widest possible range of applications compatible with its use: from small aircraft with electric propulsion—where the hydrogen fuel cell will enable a substantial increase in range and payload compared to battery-powered aircraft (potentially partially covering the regional aviation segment)—to aircraft powered by gas turbines using liquid hydrogen as fuel, potentially applicable to small or medium-sized commercial aircraft.",
        description3: "Ajusa is participating in the development line focused on a propulsion system powered by a fuel cell, developing and providing the fuel cell module, which incorporates its own 50 kW stack.",
        description4: "Project funded by the European Union – NextGenerationEU, aligning with the EU’s political priorities, in this case with the European Green Deal, whose impact is transforming the EU into a modern, resource-efficient and competitive economy: <a href='https://ec.europa.eu/info/strategy/priorities-2019-2024_es'><u>https://ec.europa.eu/info/strategy/priorities-2019-2024_es</u></a>"
      }
    },

    contacto: {
      titulo: "CUSTOMER CARE",
      formulario: {
        nombre_apellidos: "First name and family name(s)*",
        empresa: "Company*",
        email: "Email*",
        mensaje: "Message*",
        politicas: "Click here to read and accept the privacy policy",
        newsletter: "I want to receive news about Ajusa.",
        btn_enviar: "SEND",
      },
      direccion: {
        titulo: "WORLDWIDE HEADQUARTERS",
        direccion: "Parque Empresarial Ajusa, Calle 1, no. 1 · 02006 · ALBACETE (Spain) · Apdo./P.O. Box 415 (02080)",
        telefono: "Tel.: +34 967 216 212",
        fax: "Fax: +34 967 216 214 - 967 240 499",
        email: "Email: <a href='mailto:ajusa@ajusa.es'>ajusa@ajusa.es</a>"
      },
      trabaja: {
        titulo: "WORK WITH US",
        texto: "At Ajusa we strive to grow every day. If you want to be a part of our great family, complete this form and attach your resume.",
        envia_cv: "SEND RESUME",
      },
    },
    trabaja_con_nosotros: {
      intro: {
        titulo: "<span class=’bold’>work</span> with us",
        texto: "At AJUSA there is always room reserved for talent. We strive to grow every day. If you want to be a part of our great family, complete this form and attach your resume."
      },
      texto: "At Ajusa we strive to grow every day. If you want to be a part of our great family, complete this form and attach your resume.",
      boton: "send resume"
    },
    formulario: {
      nombre: "Name",
      nombre_apellidos: "Name and surnames",
      apellidos: "Surnames",
      email: "Email",
      mensaje: "Message",
      fecha_nacimiento: "Date of birth",
      dia: "Day",
      mes: "Month",
      anyo: "Year",
      area_interes: "Area of interest",
      trabaja_actualmente: "Are you working currently?",
      motivo: "Reason for your query",
      si: "Yes",
      no: "No",
      carta_presentacion: "Cover letter",
      tipos_contacto: {
        'general': "General, contact details, branches",
        'comercial': "Commercial",
        'formacion': "Training",
        'asistencia_tecnica': "Technical Support",
        'catalogo': "Request paper catalogue"
      },
      meses: {
        January: "Enero",
        February: "Febrero",
        March: "Marzo",
        April: "Abril",
        May: "Mayo",
        June: "Junio",
        July: "Julio",
        August: "Agosto",
        September: "Septiembre",
        October: "Octubre",
        November: "Noviembre",
        December: "Diciembre"
      },
      archivo_adjunto: "Attach file",
      adjuntar_cv: "Attach CV",
      empresa: "Company",
      formulario: "Full address (indicate postcode and city/town)",
      referencia: "Product reference",
      introduce_mail: "Enter your email",
      tipo_catalogo: "Type of catalogue",
      pais: "Country",
      telefono: "Telephone no.",
      quiero_recibir: "I want to receive news about Ajusa.",
      acepto_comunicaciones: "I accept receipt of the newsletter or other communications from your company.",
      otros_procesos: "I want to be included in other Ajusa recruitment processes that may be of interest to me.",
      he_leido: "I consent to the use my data for the purposes indicated in the",
      y_acepto: "privacy policy",
      enviar_comentario: "Send comment",
      comentario_enviado: "Comment sent",
      texto_comentario_enviado: "Thank you for your comment. We will review and publish it as soon as possible.",
      enviar: "Send",
      enviado: "Sent",
      popup: {
        claim: "Click here to read and accept the privacy policy",
        intro: "BASIC INFORMATION ABOUT DATA PROTECTION",
        textos: [{
            titulo: "Company responsible for data processing",
            texto: "Auto Juntas SAU"
          },
          {
            titulo: "Address of responsible company",
            texto: "Parque Empresarial Ajusa, CM 332, Km 2.2, Calle 1, no. 1, Postcode 02006, Albacete (Albacete, SPAIN)"
          },
          {
            titulo: "Purpose",
            texto: "We will use your data to respond to your requests and provide our services."
          },
          {
            titulo: "Advertising",
            texto: "We will only send you advertising with your prior authorisation, which you can give by checking the corresponding box provided for such purpose."
          },
          {
            titulo: "Legal Standing",
            texto: "We will only process your data with your prior consent, which you can give by checking the corresponding box provided for such purpose."
          },
          {
            titulo: "Recipients",
            texto: "In general, only duly authorised Ajusa employees will have access to the information we request from you."
          },
          {
            titulo: "Rights",
            texto: "You are entitled to know what information we have about you, correct and delete it, as explained in the additional information available on our website."
          },
          {
            titulo: "Additional information",
            texto: "For further information, please visit the “YOUR DATA IS SAFE WITH US” section on our website."
          }
        ],
        boton: "I understand"
      }
    },
    footer: {
      siguenos: "Follow us",
      en_redes: "Follow us on social media",
      twitter: "Follow us on X",
      facebook: "Follow us on Facebook",
      instagram: "Follow us on Instagram",
      canal: "Subscribe to the channel",
      contacto: "Contact",
      mapa_web: "Sitemap",
      Privacidad: "Privacy Policy",
      datos_seguros: "Your data is safe with us",
      cookies: "Cookie Policy",
      aviso_legal: "Legal Notice",
    },
    error_404: {
      intro: "<span class=’bold’>PAGE</span> NOT FOUND",
      nombre: "404 Error",
      texto: "Sorry! The page you are trying to access no longer exists or has been moved to a different location.",
      boton: "Back to home"
    },
    otras_secciones: {
      productos: {
        titulo: "Products",
        texto: "On-going work in various lines of research that allow us to develop an extensive product and service offering.",
        boton_texto: "Access"
      },
      tecnologia: {
        titulo: "Technology",
        texto: "We create a sustainable future through the development of alternative energy sources based on the use of hydrogen.",
        boton_texto: "Access"
      },
      proyectos: {
        titulo: "R&D&I Projects",
        texto: "Pioneers in the development of R&D&I projects that position us as the leading company in hydrogen technology research and projects.",
        boton_texto: "Access"
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/index.js